import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    AI_TRANSLATE: null,
  },
  'AITranslation',
);
